export class Till {
    public id?: number
    public name?: string
    public state?: string
    public agencyId?: number
    public agencyName?: string
    public companyId?: number
    public companyName?: string
    public services?: string[]
    public cashierFullname?: string
    public cashierPhone?: string
    public assignationStart?: Date | null
    public assignationEnd?: Date | null

    constructor(args: {
        id?: number,
        name?: string,
        state?: string,
        agencyId?: number,
        agencyName?: string,
        companyId?: number,
        companyName?: string,
        services?: string[],
        cashierPhone?: string,
        cashierFullname?: string,
        assignationStart?: Date | null,
        assignationEnd?: Date | null
    }) {

        this.id = args.id
        this.name = args.name
        this.state = args.state
        this.agencyId = args.agencyId
        this.agencyName = args.agencyName
        this.companyId = args.companyId
        this.companyName = args.companyName
        this.services = args.services
        this.cashierPhone = args.cashierPhone
        this.cashierFullname = args.cashierFullname
        this.assignationStart = args.assignationStart
        this.assignationEnd = args.assignationEnd
    }

    get displayedState(): string {
        const states: Record<string, string> = {
            'OPEN': 'OPEN',
            'CLOSED': 'CLOSED'
        }
        return this.state ? (states[this.state] ?? this.state) : ''
    }

    static fromJSON(jsonData: any): Till {
        return new Till({
            id: jsonData.id,
            name: jsonData.name,
            state: jsonData.state,
            agencyId: jsonData.agency_id,
            agencyName: jsonData.agency_name,
            companyId: jsonData.company_id,
            companyName: jsonData.company_name,
            services: jsonData.services ?? [],
            cashierPhone: jsonData.user_phone || '',
            cashierFullname: jsonData.user_fullname || '',
            assignationStart: jsonData.assignation_start ? new Date(jsonData.assignation_start) : null,
            assignationEnd: jsonData.assignation_end ? new Date(jsonData.assignation_end) : null
        })
    }
}
